import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import LoadingScreen from '../components/LoadingScreen';
import { PATH_PAGE } from '../routes/paths';
import { canAccessDashboardPath } from '../utils/routePermissions';

// ----------------------------------------------------------------------

PermissionGuard.propTypes = {
  children: PropTypes.node,
};

/**
 * Dashboard route guard: applies SidebarConfig permission/role rules.
 * Unauthorized users are sent to the Access Denied page (/403).
 * Auth (login) remains AuthGuard's responsibility.
 */
export default function PermissionGuard({ children }) {
  const { user, isInitialized, isAuthenticated } = useAuth();
  const { pathname } = useLocation();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  // AuthGuard should already block guests; keep safe if used alone
  if (!isAuthenticated || !user) {
    return <>{children}</>;
  }

  if (!canAccessDashboardPath(user, pathname)) {
    return <Navigate to={PATH_PAGE.page403} replace />;
  }

  return <>{children}</>;
}
